var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2499 12.7499C20.6641 12.7499 20.9999 12.4141 20.9999 11.9999C20.9999 11.5857 20.6641 11.2499 20.2499 11.2499H3.74988C3.33568 11.2499 2.99988 11.5857 2.99988 11.9999C2.99988 12.4141 3.33568 12.7499 3.74988 12.7499H20.2499Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60862 17.9192C8.90148 18.2121 9.37631 18.2121 9.66917 17.9192C9.96204 17.6263 9.96204 17.1515 9.66917 16.8586L4.81043 11.9999L9.66917 7.14116C9.96204 6.8483 9.96204 6.37347 9.66917 6.08061C9.37631 5.78775 8.90148 5.78775 8.60862 6.08061L3.22397 11.4653L3.21955 11.4696C2.92666 11.7625 2.92666 12.2373 3.21955 12.5302L3.2196 12.5302L8.6086 17.9192L8.60862 17.9192Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.5d755180.svg";
export { ForwardRef as ReactComponent };